<!-- components/SafeIcon.vue -->
<template>
    <i
            v-if="type"
            :class="['iconfont', `icon-${type}`, customClass]"
            :style="{
      fontSize: size + 'px',
      color: color,
      ...customStyle
    }"
            @click="$emit('click')"
    />
    <!-- 备用显示 -->
    <span v-else class="icon-placeholder">
    {{ fallbackText }}
  </span>
</template>

<script>
    export default {
        name: 'SafeIcon',
        props: {
            type: String,
            size: {
                type: [Number, String],
                default: 16
            },
            color: String,
            customClass: String,
            customStyle: Object,
            fallbackText: {
                type: String,
                default: '[图标]'
            }
        },
        mounted() {
            // 检查图标是否加载成功
            this.$nextTick(() => {
                const el = this.$el
                if (el) {
                    const computedStyle = window.getComputedStyle(el, ':before')
                    const content = computedStyle.content
                    if (!content || content === 'none' || content === 'normal') {
                        console.warn(`图标 "${this.type}" 可能未正确加载`)
                    }
                }
            })
        }
    }
</script>

<style scoped>
    .icon-placeholder {
        display: inline-block;
        width: 1em;
        height: 1em;
        background: #f5f5f5;
        border: 1px dashed #d9d9d9;
        border-radius: 2px;
        font-size: 12px;
        text-align: center;
        line-height: 1;
        color: #999;
    }
</style>